"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GameCourseLevel = exports.GameEventType = void 0;
var GameEventType;
(function (GameEventType) {
    GameEventType["START"] = "START";
    GameEventType["PLAYER_JOINED"] = "PLAYER_JOINED";
    GameEventType["PLAYER_LEFT"] = "PLAYER_LEFT";
    GameEventType["PLAYER_CHANGED"] = "PLAYER_CHANGED";
    GameEventType["SHOT"] = "SHOT";
    GameEventType["HOLE_CHANGED"] = "HOLE_CHANGED";
    GameEventType["END"] = "END";
    GameEventType["CANCELED"] = "CANCELED";
})(GameEventType = exports.GameEventType || (exports.GameEventType = {}));
var GameCourseLevel;
(function (GameCourseLevel) {
    GameCourseLevel["BEGINNER"] = "BEGINNER";
    GameCourseLevel["INTERMEDIATE"] = "INTERMEDIATE";
    GameCourseLevel["EXPERT"] = "EXPERT";
})(GameCourseLevel = exports.GameCourseLevel || (exports.GameCourseLevel = {}));
//# sourceMappingURL=API.js.map